export const BROADCAST_EVENTS = {
  INITIALIZE: 'INITIALIZE',
  CHECK_TAB_EXITS: 'CHECK_TAB_EXITS',
  ACTIVE_TAB: 'ACTIVE_TAB',
}